import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import type {} from '@redux-devtools/extension';

import storage from '../storage';
import {
  addSite,
  deleteSiteByUUID,
  getSiteByProjectId,
  getSiteByUUID,
  isSiteExist,
  removeUnauthorizedSites,
  resetSites,
  updateSite,
} from './site-store.actions';
import { initialState, STORE_NAME } from './site-store.constant';
import { SiteStoreActions, SiteStoreState } from './site-store.types';

export const useSiteStore = create<SiteStoreState & SiteStoreActions>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        addSite: addSite(set, get),
        updateSite: updateSite(set, get),
        deleteSiteByUUID: deleteSiteByUUID(set, get),
        getSiteByUUID: getSiteByUUID(get),
        getSiteByProjectId: getSiteByProjectId(get),
        isSiteExist: isSiteExist(get),
        resetSites: resetSites(set),
        removeUnauthorizedSites: removeUnauthorizedSites(set, get),
      }),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => storage),
        onRehydrateStorage: () => state => state?.removeUnauthorizedSites(),
      }
    ),
    { name: STORE_NAME }
  )
);
